import Typography from "./ui/typeography/typeography";

export function HelpRootPage() {
  return (
    <div className="flex flex-col gap-2 lg:max-w-5xl">
      <img
        src="/assets/help-pages-guidelines-graphic.png"
        alt="Help page guidelines graphic"
        width={480}
        height={480}
        className="mb-4 w-full max-w-3xl self-center rounded-lg"
      />

      <Typography variant={"p"} className="italic">
        The Mi Trip Planner includes transit information from participating agencies across Michigan. View the full list on our website here:{" "}
        <a
          href="https://miruralmobility.org/"
          className="text-blue-600 underline hover:text-blue-800 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://miruralmobility.org/
        </a>
      </Typography>
 
    </div>
  )
}
